import { Observable } from 'rxjs';
import { Theme, iThemeSetting } from '../models';

export abstract class IThemeService {
    public abstract currentTheme$: Observable<iThemeSetting>;
    public abstract getThemeValue(themeVariable: string): string;
    public abstract set(theme: Theme): void;
}
